import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    isLoading: Boolean,
    reloadStatus: Boolean,
  };

  connect() {
    if (this.isLoadingValue && this.reloadStatusValue) {
      setTimeout(() => {
        const frameElement = this.element.closest("turbo-frame");
        const frameId = frameElement ? frameElement.id : null;

        if (frameId) {
          Turbo.visit("/portal/membership_status", {
            frame: frameId,
          });
        }
      }, 100);
    }
  }
}
